import React from 'react';
import { formatTimeFromPresent } from '../../shared/dateUtils';
import { getLiveStreamImageUrl, getLiveStreamPath } from '../utils';
import {
  newRegistrationUrl,
  newAccountUrl,
  isAccountLoggedIn,
  accountSignInUrl,
  isRegistered,
  isEventRegisterable
} from '../../shared/apiUtils';
import { getEventSlug } from '../../shared/configUtils';
import { CopyToClipboard } from 'react-copy-to-clipboard';

interface Props {
  liveStream: any,
}

interface State {
  copiedStreamId: boolean,
  copiedStreamPassword: boolean,
}

class SingleLiveStreamBody extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      copiedStreamId: false,
      copiedStreamPassword: false,
    };
  }

  render() {
    let { liveStream } = this.props;
    let startsAt = formatTimeFromPresent(liveStream.iso_starts_at);
    let endsAt = formatTimeFromPresent(liveStream.iso_ends_at);
    return(
      <div className="p3">
        <div className="flexbox-wrapper">
          <div className="flexbox-item-small pthalf pr2">
            <div className="flexbox-align-center mr2 live-stream-image-box">
              <img src={getLiveStreamImageUrl(liveStream)} className="img-responsive br4" />
            </div>
          </div>
          <div className="flexbox-item fw-b">
            <div className="flexbox-wrapper fs-md fw-sb">
              <span className="cs-live-blue-alt">{startsAt} — {endsAt}</span>
            </div>
            <div className="fs-xl fw-sb cs-color-black">
              {liveStream.name}
            </div>
          </div>
        </div>
        <div className="mt56">
          {this.renderBody(liveStream)}
        </div>
      </div>
    );
  }

  renderBody(liveStream) {
    let isLoggedIn = isAccountLoggedIn()
    let requireAccount = !isLoggedIn && liveStream.require_account;
    let requireRegistration = !isRegistered() && liveStream.require_registration;
    let showStreamIdOrPassword = (liveStream.stream_id || liveStream.stream_password);
    let { copiedStreamId, copiedStreamPassword } = this.state;
    if(liveStream.stream_type == "Embed" || liveStream.stream_type == "Interactive") {
      return(
        this.renderStreamButton(liveStream)
      )
    } else if(requireAccount || requireRegistration) {
      return(
        <div className="px2 br5 border-color-gray cs-bg-very-light-gray">
          <div className="flexbox-wrapper py2">
            <div className="live-stream-password-icon-wrapper">
              <i className="fas fa-lock cs-color-blue live-stream-password-icon" />
            </div>
            <span className="cs-color-black fs-sm mr2">
              {this.renderMessage(requireRegistration, requireAccount)}
            </span>
          </div>
        </div>
      )
    } else {
      return(
        <React.Fragment>
          {showStreamIdOrPassword &&
            <div className="px2 br5 border-color-gray cs-bg-very-light-gray mb3">
              {liveStream.stream_id &&
                <React.Fragment>
                  <div className="flexbox-wrapper flexbox-align-all-center py1">
                    <div className="live-stream-password-icon-wrapper">
                      <img
                        className="mr2 live-stream-password-icon"
                        src="/assets/icons/ID-icon.svg"
                        height="16px"
                        width="16px"
                      />
                    </div>
                    <span className="cs-color-black fs-sm stream-label">Stream ID</span>
                    <span className="cs-color-black fs-sm fw-b">{liveStream.stream_id}</span>
                    <CopyToClipboard text={liveStream.stream_id}
                      onCopy={() => this.setState({copiedStreamId: true})}>
                      <button className="cs-light-blue-btn flexbox-right">
                        {copiedStreamId ? "Copied!" : "Copy"}
                      </button>
                    </CopyToClipboard>
                  </div>
                  {liveStream.stream_password &&
                    <hr className="m0" />
                  }
                </React.Fragment>
              }
              {liveStream.stream_password &&
                <div className="flexbox-wrapper flexbox-align-all-center py1">
                  <div className="live-stream-password-icon-wrapper">
                    <i className="fas fa-unlock cs-color-blue live-stream-password-icon" />
                  </div>
                  <span className="cs-color-black fs-sm stream-label">Password</span>
                  <span className="cs-color-black fs-sm fw-b">{liveStream.stream_password}</span>
                  <CopyToClipboard text={liveStream.stream_password}
                      onCopy={() => this.setState({copiedStreamPassword: true})}>
                      <button className="cs-light-blue-btn flexbox-right">
                        {copiedStreamPassword ? "Copied!" : "Copy"}
                      </button>
                    </CopyToClipboard>
                </div>
              }
            </div>
          }
          {this.renderStreamButton(liveStream)}
        </React.Fragment>
      )
    }
  }

  renderStreamButton(liveStream) {
    let props = {};
    if(!["Embed", "Interactive", "Playback"].includes(liveStream.stream_type)) {
      props["target"] = "_blank";
      props["data-cs-id"] = liveStream.id;
      props["data-cs-type"] = "live_stream";
    }
    return(
      <a
        className="ahoy-track cs-violet-gradient-btn cs-btn-full cs-new-large-btn"
        href={getLiveStreamPath(liveStream)}
        {...props}
      >
        <i className="fas fa-video pr1" />
        Watch Livestream
      </a>
    )
  }

  renderMessage(requireRegistration, requireAccount) {
    if(requireAccount) {
      return(
        <React.Fragment>
          To view the Livestream,
          <a href={newAccountUrl()} className="cs-btn-link-light-blue"> create an account </a>
          or <a href={accountSignInUrl()} className="cs-btn-link-light-blue">login</a>
        </React.Fragment>
      )
    } else {
      if(isEventRegisterable()) {
        return(
          <React.Fragment>
            Registration is required to view the Livestream.
            <a href={newRegistrationUrl(getEventSlug())} className="cs-btn-link-light-blue"> Register Here →</a>
          </React.Fragment>
        )
      } else {
        return(
          <React.Fragment>
            Registration is currently not available.
          </React.Fragment>
        )
      }
    }
  }

}

export default SingleLiveStreamBody;
